import type { SyncState } from '@annoteer/sync-layer';

/**
 * How the state readout's `conn` row should read.
 *
 * The Yjs socket connects on `connectToDocument`, which runs when a document
 * (or the whiteboard) opens -- NOT at panel mount. So a surface with nothing
 * open is correctly `disconnected`, and that has been documented as expected
 * since 2026-05-23.
 *
 * ⚠️ Documented is not the same as legible. On 2026-09-22 a real session read
 * `conn: disconnected` while confirming a build tag, before opening anything,
 * and reported it as a fault -- reasonably, because "disconnected" is what a
 * dropped socket also says. The readout was right and still cost time.
 *
 * So the row now distinguishes the two. `idle (no document)` means nothing has
 * asked for a room yet; a bare `disconnected` means a room was asked for and
 * the socket is not up, which IS worth chasing.
 */
export function formatConnectionRow(state: SyncState, hasOpenDocument: boolean): string {
  if (state === 'disconnected' && !hasOpenDocument) return 'idle (no document)';
  return state;
}
